<script setup lang="ts">
import { TabsIndicator, TabsList, TabsRoot, TabsTrigger } from 'reka-ui'

defineProps<{
  years: Array<string | number>
  orientation: 'horizontal' | 'vertical'
}>()

const model = defineModel<string | undefined>()
</script>

<template>
  <TabsRoot v-model="model" :orientation="orientation" activation-mode="manual">
    <TabsList
      class="flex gap-1 sm:gap-2.5 relative"
      :class="{
        'flex-col': orientation === 'vertical',
      }"
    >
      <TabsIndicator
        class="absolute rounded-lg transition-transform"
        :class="{
          'w-full h-[--reka-tabs-indicator-size] translate-y-[--reka-tabs-indicator-position]': orientation === 'vertical',
          'h-full w-[--reka-tabs-indicator-size] translate-x-[--reka-tabs-indicator-position]': orientation === 'horizontal',
        }"
      >
        <div class="size-full rounded-lg bg-blurple-500 text-moss-200 z-0" />
      </TabsIndicator>
      <TabsTrigger
        v-for="year in years"
        :key="year"
        :value="String(year)"
        class="rounded-lg py-2 px-1 sm:px-3 sm:py-4 w-full inline-block data-[state=active]:text-moss-200 transition-colors z-[1]"
        :class="{
          'text-start': orientation === 'vertical',
        }"
      >
        {{ year }}
      </TabsTrigger>
    </TabsList>
  </TabsRoot>
</template>
